import { api } from "../../../infra/api";
import { URLS } from "../../../infra/URLS";

export default async function getBotijao() {
  const data = await api.get(`${URLS.BOTIJOES_API}`)
  .then((resp) => resp?.data);

  return data;
}
